import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/store';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AdminHeaderComponent } from '../../shared/widgets/admin-header/admin-header.component';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { MdaSidemenuComponent } from '../../shared/widgets/mda-sidemenu/mda-sidemenu.component';
import { getSettingsStore } from '../../core/store/selectors/settings.selectors';
import { TaoSidemenuComponent } from '../../shared/widgets/tao-sidemenu/tao-sidemenu.component';

@Component({
  selector: 'app-tax-area-office',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    AdminHeaderComponent,
    NzLayoutModule,
    TaoSidemenuComponent,
  ],
  templateUrl: './tax-area-office.component.html',
  styleUrl: './tax-area-office.component.css',
})
export class TaxAreaOfficeLayoutComponent {
  store = inject(Store<AppState>);

  settingsStoreSub: Subscription;

  isCollapsed = signal(false);

  ngOnInit(): void {
    this.settingsStoreSub = this.store
      .pipe(select(getSettingsStore))
      .subscribe((settingsStore) => {
        this.isCollapsed.set(settingsStore.sideMenuCollapsedState);
      });
  }

  ngOnDestroy(): void {
    if (this.settingsStoreSub) this.settingsStoreSub.unsubscribe();
  }
}
